import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'international-language_selector_language_click-click';
/**
 * Language selector on click event tracking.
 */ export function trackInternationalLanguageSelectorLanguageClickClick(Display_type, Language_selector_location2, Language_selected3) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            Display_type: Display_type,
            Language_selector_location2: Language_selector_location2,
            Language_selected3: Language_selected3
        }
    });
}
